import * as React from 'react';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import {
    StyledWrapper,
    StyledContent,
    StyledModal,
    StyledHeader,
    StyledIcon,
    StyledFooter,
    StyledTitle,
} from '@process-advisor/process-miner/components/modal/modal.styles'
import { Button } from '@process-advisor/process-miner/components/shared/button';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import styled from 'styled-components';
import { Typography } from '@mui/material';
import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chart from '@process-advisor/process-miner/modals/histogram/histogramChart'

const Histogram = styled.div`
    width: 900px;
    height: 600px;
    border: hidden;
    canvas {
        outline: none;
    };
`;

const Options = styled.div`
    padding-top: 5px;
    padding-left: 30px; 
    display: flex;
    justify-content: center;
`;

type Props = {
    props: {
        source: string,
        title: string,
    },
}

export type Data = []

export const HistogramModal: React.FC = () => {
    const [data, setData] = React.useState<Data[]>([]);
    const [props, setProps] = React.useState<{ source:string, title: string,}>({ source: '', title: ''});
    const [open, setOpen] = React.useState(false);
    const [title, setTitle] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [totalDesc, setTotalDesc] = React.useState('');
    const [showCloseIcon, setShowCloseIcon] = React.useState(true);
    const [showButtons, setShowButtons] = React.useState(true);
    const [duration, setDuration] = React.useState('hrs');

  
    function handleChange(e) {
      setDuration(e.target.value)
      apiProvider.changeDurationLabel({duration: e.target.value})
      setDescription(apiProvider.getHistogramDescription().replace('^^^',duration))
      setTotalDesc(apiProvider.getHistogramTotal())
 
      setData(deriveHistogramArray(apiProvider.getHistogramArray(),e.target.value))
    }
 
    function onClose() {
        setOpen(false)
    }

    useApiListener(
        Event.openHistogramModal,
        ({ props }: Props) => {
            setOpen(true);
            setProps(props);
            setTitle('Histogram')
            setDescription(apiProvider.getHistogramDescription().replace('^^^',duration))
            setTotalDesc(apiProvider.getHistogramTotal())
            const timer = setTimeout(() => {
                setData(deriveHistogramArray(apiProvider.getHistogramArray(),duration));
            }, 100);
            return () => clearTimeout(timer);
        }
    );

    function deriveHistogramArray(array,duration) {
        let tempArray = []
        for (let i = 0; i < array.length; i++) {
          if (duration === 'secs') {tempArray.push(array[i].secs)}
          if (duration === 'mins') {tempArray.push(array[i].mins)}
          if (duration === 'hrs') {tempArray.push(array[i].hrs)}
          if (duration === 'days') {tempArray.push(array[i].days)}
        }
        return tempArray
    }
    return (
        <StyledWrapper open={open} onClose={onClose}>
            <StyledModal >
                <StyledHeader>
                    <StyledTitle>{title}</StyledTitle>
                    {showCloseIcon ? <StyledIcon onClick={onClose} /> : <div />}
                </StyledHeader>
                <Options>
                    <SingleBlock width="85%" align="center">   
                    <Typography
                        variant="caption"
                        align="center"
                        sx={{ fontSize: '14px', fontWeight: '600', paddingTop: 1, fontFamily: 'system-ui'
}}
                        component="div">
                        {description}
                    </Typography>
                    <Typography
                        variant="caption"
                        align="center"
                        sx={{ fontSize: '14px', fontWeight: '600', paddingTop: 1, fontFamily: 'system-ui'
}}
                        component="div">
                        {totalDesc}
                    </Typography>
                    </SingleBlock>
                    <SingleBlock width="15%">
                    { data.length > 0 ?
                    <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
                        <Select
                            id="demo-select-small"
                            value={duration}
                            sx={{ fontSize: '12px' }} 
                            onChange={handleChange}
                        >
                        <MenuItem sx={{ fontSize: '12px' }} value={'secs'}>secs</MenuItem>
                        <MenuItem sx={{ fontSize: '12px' }} value={'mins'}>mins</MenuItem>
                        <MenuItem sx={{ fontSize: '12px' }} value={'hrs'}>hrs</MenuItem>
                        <MenuItem sx={{ fontSize: '12px' }} value={'days'}>days</MenuItem>
                        </Select>
                    </FormControl>
                    : '' }
                    </SingleBlock>
                </Options>
                <StyledContent>
                    <Histogram>
                        <Chart
                            chartData={data}
                            axisTitle={'Duration ('+ duration + ')'} >
                        </Chart>
                    </Histogram>
                </StyledContent>
                {
                    showButtons && (
                        <StyledFooter>
                            <Button label='Close' onClick={onClose} disabled={false} />
                        </StyledFooter>
                    )
                }
            </StyledModal>
        </StyledWrapper>
    );
};

